// extracted by mini-css-extract-plugin
module.exports = {"Communicate":"communicateTop_Communicate__ooxth"};